var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { StorageService } from './abstract-storage.service';
var LocalStorageService = /** @class */ (function (_super) {
    __extends(LocalStorageService, _super);
    function LocalStorageService() {
        var _this = _super.call(this, window.localStorage || window.sessionStorage || {}) || this;
        window.addEventListener('storage', function (e) {
            if (e.key) {
                _this._changeEmitter.emit({ key: e.key, value: e.newValue });
            }
        });
        return _this;
    }
    return LocalStorageService;
}(StorageService));
export { LocalStorageService };
